import $ from 'jquery'

class CollapsibleItem {
  constructor(el) {
    if (!el.classList.contains('block--type--collapsible-item')) {
      return
    }

    this.el = el
    this.toggler = el.querySelector('.toggle')
    this.heading = el.querySelector('.collapsible-button')
    this.content = el.querySelector('.collapsible-content')
    this.grouping = el.dataset.grouping
    this.delay = 500

    this.languageButtons = el.querySelectorAll('.language-btn')
    this.transcripts = {
      en: this.content ? this.content.querySelectorAll('.transcript-en') : [],
      es: this.content ? this.content.querySelectorAll('.transcript-es') : [],
    }

    if (this.toggler) {
      this.toggler.addEventListener('click', () => this.toggle())
    }
    if (this.heading) {
      this.heading.addEventListener('click', () => this.toggle())
    }

    if (this.languageButtons.length) {
      this.languageButtons.forEach(btn =>
        btn.addEventListener('click', (e) => {
          e.stopPropagation()
          this.switchLanguage(btn.dataset.lang)
        })
      )
      this.initLanguage()
    }
  }

  initLanguage() {
    const activeBtn = this.el.querySelector('.language-btn.active')
    const lang = activeBtn?.dataset.lang || 'en'
    this.switchLanguage(lang, false)
  }

  open() {
    this.el.classList.add('opened')
    $(this.content).stop(true, false).slideDown(this.delay, () => {
      const rect = this.el.getBoundingClientRect()
      const header = document.querySelector('.menu-container')
      const yOffset = (header.clientHeight + 16) * -1
      const y = rect.top + window.pageYOffset + yOffset

      if (rect.y < yOffset * -1) {
        window.scrollTo({top: y, behavior: 'smooth'})
      }
    })
  }

  close() {
    this.el.classList.remove('opened')
    $(this.content).stop(true, false).slideUp(this.delay)
  }

  toggle() {
    if (this.isOpened()) {
      this.close()
    } else {
      this.closeAll()
      this.open()
    }
  }

  closeAll() {
    if (!this.grouping) {
      return
    }

    $(`[data-grouping="${this.grouping}"]`)
      .removeClass('opened')
      .find('.collapsible-content')
      .slideUp(this.delay)
  }

  isOpened() {
    return this.el.classList.contains('opened')
  }

  setTranscriptVisibility(transcriptEl, show, animate = true) {
    if (!transcriptEl) {
      return
    }

    if (!animate || transcriptEl.dataset.animate === 'false') {
      transcriptEl.style.display = show ? 'block' : 'none'
      return
    }

    if (show) {
      $(transcriptEl).stop(true, false).slideDown(this.delay)
    } else {
      $(transcriptEl).stop(true, false).slideUp(this.delay)
    }
  }

  switchLanguage(lang, animate = true) {
    this.languageButtons.forEach(btn => {
      btn.classList.toggle('active', btn.dataset.lang === lang)
    })

    Object.entries(this.transcripts).forEach(([key, nodeList]) => {
      nodeList.forEach(transcriptEl => {
        this.setTranscriptVisibility(transcriptEl, key === lang, animate)
      })
    })
  }

}

export default CollapsibleItem
